






































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { Location } from "vue-router";
import { formatCurrency } from "@/shared/currency";
import { FetchState, Transaction, TransactionSource, TransactionFilter, Expense, HsabSsoDestination } from "@/shared/types";
import TabGroup from "@/shared/components/ui/TabGroup.vue";
import Tab from "@/shared/components/ui/Tab.vue";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import CashAccountTab from "./CashAccountTab.vue";
import { useHsaStore } from "@/shared/store/hsa";
import { useHsaPendingTransactionStore } from "@/shared/store/hsaPendingTransaction";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component({
  components: {
    CashAccountTab,
    TabGroup,
    Tab,
    SsoDeepLink,
  }
})
export default class CashAccountTabs extends Vue {

  hsaStore = useHsaStore();
  pendingTransactionStore = useHsaPendingTransactionStore();
  custodianSettingsStore = useCustodianSettingsStore();

  @Prop() // when used for customer service, we can't show expenses due to PHI
  includeExpenses: boolean;

  @Prop()
  page: number;

  @Prop()
  routeToPages: (pageNumber: number, filter: TransactionFilter) => Location;

  @Prop()
  transactionFilter: TransactionFilter;

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  formatCurrency = formatCurrency;
  TransactionFilter = TransactionFilter;

  mounted (): void {
    this.loadPage();
    this.refresh();
    this.$on("tab-clicked", (event, tab) => {
      this.handleTabChange(tab.type);
    });
  }

  get cashAccountPendingAmount (): number {
    if (!this.pendingTransactionStore.isLoading) {
      return this.pendingTransactionStore.transactions.reduce((accumulator: number, model) =>
        accumulator + model.amount, 0);
    }
    else {
      return 0;
    }
  }

  get isLoaded (): boolean {
    return this.hsaStore.fetchState === FetchState.Loaded;
  }

  get ssoDestination () {
    return HsabSsoDestination.CashAccountDetails;
  }

  handleTabChange (transactionFilter): void {
    this.refresh();
    this.$router.push(this.routeToPages(1, transactionFilter));
  }

  switchPage (newPage) {
    this.$router.push(this.routeToPages(newPage, this.transactionFilter));
  }

  @Watch("$props", { deep: true })
  loadPage () {
    this.hsaStore.loadHsaTransactionsDictionary({
      pageNumber: this.page,
      transactionFilter: this.transactionFilter,
      includeExpenses: this.includeExpenses,
      username: this.username,
      partnerId: this.partnerId
    }).catch(() => null); // the store rethrows the error
    this.hsaStore.setHsaPageNumber(this.page);
  }

  expensesForReimbursement (item: Transaction): Expense[] {
    if (this.includeExpenses && (item.source === TransactionSource.Reimbursement ||
      item.source === TransactionSource.DebitCard || item.source === TransactionSource.Disbursement)) {
      const reimbursement = this.hsaStore.reimbursementExpenses.filter(x => x.bankTransactionId === Number(item.id));
      if (reimbursement.length > 0) {
        return reimbursement[0].appliedExpenses;
      }
    } else {
      return null;
    }
  }

  refresh () {
    this.pendingTransactionStore.loadPendingTransactions({ username: this.username, partnerId: this.partnerId });
  }
}

